/** * Created by lobin on 2019/4/1. */
<template>
  <div class="introduce">
    <div class="detail-single inner home-inner protocol">
        <div class="detail-text">          
            <h1 class="title">蓉e聘-C端用户协议</h1>
尊敬的用户：
<br/>在您成为蓉e聘-C端注册用户，使用蓉e聘-C端提供的服务之前，请您认真阅读蓉e聘-C端《用户协议》（以下简称“协议”），更好地了解我们所提供的服务以及您享有的权利和承担的义务。您一旦开始使用蓉e聘-C端服务，即表示您已经确认并接受了本协议中的全部条款。
<br/>本协议系由您（以下简称“用户”或“您”）与成都蓉易聘网络科技有限责任公司（以下简称“蓉易聘公司”或“我们”）（公司地址：四川省成都市天府新区华府大道一段1号3栋1单元7层710、711号，联系电话：17781698372）就我们提供的蓉e聘-C端软件（以下简称“本平台”）所订立的相关权利义务规范。蓉e聘-C端软件是一个严肃纯净的招聘服务软件，请您在注册、使用蓉e聘-C端软件之前，认真阅读以下条款。
<br/><p>（温馨提示：为了您的合法权益不受损害，平台建议您在使用蓉e聘-C端找工作前，仔细阅读 <a href="https://m.zhipin.com/mpa/html/mix/safe-guid?test=1" target="_blank">《安全求职指南》</a>，谨防各类求职陷阱）。</p>
<b>一、注册条款的接受</b>
<br/>依据《网络安全法》《互联网用户账号信息管理规定》等法律法规的要求，您在蓉e聘-C端注册页面完成手机短信验证并勾选同意蓉e聘-C端《用户协议》等相关协议，即表示您已经阅读并且同意与蓉易聘公司达成本协议，成为蓉e聘-C端的用户，并接受本协议中的全部注册条款以及蓉e聘-C端<router-link tag="li" to="/index/privacy" >《隐私政策》</router-link>和本平台内公布的包括但不限于<router-link tag="li" to="/index/jobPosting" >《蓉e聘-C端职位信息发布规则》</router-link>等各项协议或规则（统称“平台协议”或“平台规则”）的所有条款的约束，包括争议解决条款（详见本协议第十五条）。
<br/><b>二、用户的注册与认证</b>
<br/>1.申请注册蓉e聘-C端账号的用户应同时满足下列全部条件：在注册之日以及此后使用蓉e聘-C端服务期间必须以招聘或求职为目的；在注册之日必须年满16周岁以上。
<br/>2.为了更好地享有蓉e聘-C端平台服务，用户应遵蓉e聘-C端注册机制的要求，向蓉e聘-C端提供本人真实、准确、最新及完整的资料；注册并认证成为招聘者的用户（包括来自用人单位的用户），应保证及时更新本人提供的单位名称、职务或岗位信息、企业邮箱、等相关信息及证明材料，并确保前述信息及证明材料的真实性；用户应保证其职务行为，包括但不限于发布招聘信息、使用、转发求职者简历等均在使用本平台期间持续有效；通过认证的用户应保持其招聘账号与对应的授权单位具有唯一性。
<br/>3.依照《网络招聘服务管理规定》等相关法律法规的规定，若招
<br/>聘用户提交的材料或提供的信息不准确、不真实、不规范或有理由怀疑证明材料涉及窃取、伪造的，蓉e聘-C端有权拒绝为您提供相关功能。您可能无法使用蓉e聘-C端软件及相关服务或在使用过程中部分功能受到限制。
<br/>4.若用户故意提供虚假的身份信息、公司信息进行注册，发布虚假招聘信息或者求职信息、未经招聘企业授权的非以自身招聘为目的获取、使用求职者简历的，视为严重违反本协议，蓉e聘-C端有权暂停或终止该用户账号并停止提供服务。虚假注册、发布虚假信息给蓉e聘-C端造成经济、名誉等任何损失的，蓉e聘-C端将保留追究该用户法律责任的权利。
<br/><b>三、用户账号及安全</b>
<br/>1.用户应对利用账号所进行的一切活动负全部责任，包括任何经由蓉e聘-C端上传、张贴、发送电子邮件或任何其它方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息或其它资料，无论系公开还是私下传送，均由内容提供者承担责任。
<br/>2.用户的账号遭到未获授权的使用，或者发生其他任何安全问题时，用户应立即通知蓉e聘-C端。由于用户使用不当或者其他非因蓉e聘-C端导致的账号泄露，进而导致其资料、信息泄露的，由用户承担其不利后果。
<br/>3.蓉e聘-C端账号的所有权归蓉e聘-C端公司所有，用户完成账号注册程序后，获得蓉e聘-C端账号的使用权，且该使用权仅属于账号初始注册人。同时，用户不得赠与、借用、租用、转让或售卖蓉e聘-C端账号或者以其他方式许可他人使用蓉e聘-C端账号。其他人不得通过受赠、继承、承租、受让或者其他任何方式使用蓉e聘-C端账号。如果我们发现或者有合理理由认为账号使用者并非账号初始注册人，为保障账号安全，我们有权立即暂停或终止向该注册账号提供服务，并有权永久禁用该账号。
<br/>4.用户不得将账号主动告知第三方或提供给第三方进行使用，例如提供给第三方进行代为购买蓉e聘-C端服务等。如因此造成其他用户隐私泄露或经济损失以及本平台损失的，用户应当承担全部责任。
<br/><b>四、服务说明</b>
<br/>1.蓉e聘-C端通过互联网为用户提供网络服务，包括在线及离线的相关业务。为使用网络服务，用户应自行配备进入互联网所必需的设备，包括计算机、数据机或其它存取装置，并自行支付登录互联网所需要的费用。
<br/>2.无论是付费服务还是蓉e聘-C端的免费服务均有有效期，有效期结束后服务将自动终止。除协议另有约定外，因付费服务具有数字化商品的特殊属性，一经购买不支持七天无理由退货。
<br/>3.基于风控策略、求职安全的考虑，蓉e聘-C端可能要求部分用户补充提供材料（包括但不限于企业资质证明、承诺书、业务协议等），具体要求会在相关页面上做明确展示。如用户拒绝提供前述材料，蓉e聘-C端有权视情况暂停或终止向该用户提供部分或全部服务。
<br/>4.为落实《网络招聘服务管理规定》的核验更新义务，蓉e聘-C端可能会不定期对部分用户的企业地址、招聘授权等相关信息进行真实性审核以及更新核验(目前，该审核机制包括“环境认证”和“线下审核”)。审核过程中，用户应配合蓉e聘-C端工作人员补充相关资料，包括但不限于营业执照、资质证书/相关业务协议、授权书、被授权人身份证信息、租赁协议/水电费记录等，并允许 蓉e聘-C端工作人员对其企业 LOGO、办公环境进行审核及拍照备案(具体要求见网页说明或“小秘书”通知)。若用户拒绝，蓉e聘-C端有权视情况暂停或终止为其提供部分或全部的服务。
<br/>5.对于利用蓉e聘-C端平台从事非法活动，或言行（无论线上或者线下的）严重背离蓉e聘-C端严肃招聘目的的用户，蓉e聘-C端有权视情况暂停或终止为其提供部分或全部的服务。若该行为给蓉e聘-C端造成任何损失的，蓉e聘-C端保留追究其法律责任的权利。
<br/>6.蓉e聘-C端有权通过小秘书推送、拨打电话、发送短信或电子邮件等方式，告知用户蓉e聘-C端服务相关的广告信息、促销优惠等营销信息，以及邀请用户参与版本测试、用户体验反馈、回访等活动。除系统通知或重要信息外，用户可以通过蓉e聘-C端提供的方式选择不接收上述信息。
<br/>7.为提高蓉e聘-C端用户的招聘效率，蓉易聘公司可能会将蓉e聘-C端用户发布的职位信息共享至我们运营的关联平台及第三方合作平台。
<br/>8.为提高蓉e聘-C端用户的求职效率，蓉e聘-C端可能会在征得您的授权同意后将您在蓉e聘-C端填写的求职信息共享至我们运营的关联平台（如店长直聘，信息共享范围请详见蓉e聘-C端《隐私政策》）。在此期间，您可通过蓉e聘-C端《隐私政策》了解我们如何保障您的个人信息的安全。
<br/>9.用户应通过本平台使用相关服务；未经许可，不得通过其他第三方工具或运营平台获取蓉e聘-C端平台内的任何信息服务，包括但不限于通过第三方软件登录蓉e聘-C端账号、发布职位、浏览职位、收发简历等。如因用户使用第三方软件导致相关信息泄露的，蓉e聘-C端不承担任何责任，且用户还应承担由此给蓉e聘-C端造成的损失。
<br/>10.招聘用户若将在平台上获取的求职者简历向境外接收方提供，应按照《个人信息保护法》等相关法律法规采取必要措施确保个人信息出境合法合规。
<br/>11.关于单项服务与第三方服务的特殊约定
<br/>蓉e聘-C端软件及相关服务中包含我们以各种合法方式获取的信息或信息内容链接，同时也包括公司及其关联方合法运营的其他单项服务,这些服务在“蓉e聘-C端平台"可能以单独版块（如专场、套餐等）形式存在,蓉e聘-C端有权不时地增加、减少或改动这些特别版块的设置及服务。
<br/>用户可以在蓉e聘-C端软件中开启和使用上述单项服务功能。某些单项服务可能需要用户开通注册该项服务的账号，同时接受就该服务特别制订的协议或者其他约束其与该项服务提供者之间的规则。必要时蓉e聘-C端将以醒目的方式提供这些协议、规则供用户查阅。一旦用户开始使用上述服务，则视为其理解并接受有关单项服务的相关协议、规则的约束。
<br/>您在蓉e聘-C端软件中使用第三方提供的软件及相关服务时，除遵守本平台协议外，可能还需同意并遵守第三方的协议、相关规则。如因第三方软件及相关服务产生的争议、损失或损害，由您自行与第三方解决，蓉e聘-C端并不就此而对您或任何第三方承担任何责任。您在 蓉e聘-C端中使用第三方提供的支付服务时，请认真了解该服务的内容，充分阅读并同意相关协议条款。
<br/><b>五、有限责任条款</b>
<br/>1.蓉易聘公司将尽力为用户提供安全、及时、准确、高质量的服务，但无法对用户使用本平台服务的效果做出承诺，也不保证服务不会中断，对服务的及时性、安全性、准确性都不作保证。除非另有约定，否则用户因无法使用蓉e聘-C端服务，或使用服务未达到心理预期的，蓉e聘-C端不承担责任。
<br/>2.对于用户通过蓉易聘公司提供的服务传送的内容，蓉e聘-C端会尽合理努力按照国家有关规定严格审核，但无法完全控制经由软件/网站服务传送的内容，不保证内容的准确性、完整性或品质。因此用户在使用蓉e聘-C端服务时，可能会接触到令人不快、不适当或令人厌恶的内容。在任何情况下，蓉e聘-C端均不为用户经由软件/网站服务以张贴、发送电子邮件或其它方式传送的任何内容负责。但蓉e聘-C端有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用软件/网站服务的全部或部分，保存有关记录，并根据国家法律法规、相关政策在必要时向有关机关报告并配合有关机关的行动。
<br/>3.对于蓉e聘-C端提供的各种第三方广告信息、链接、资讯等（如有），蓉e聘-C端不保证其内容的准确性、合法性或可靠性，相关责任由广告主承担；并且，对于用户经由蓉e聘-C端服务与广告主进行联系或商业往来，完全属于用户和广告主之间的行为，与蓉e聘-C端无关。对于前述商业往来所产生的任何损害或损失，蓉e聘-C端不承担任何责任。
<br/>4.对于用户上传的照片、资料、证件、视频、内容及图片等，蓉e聘-C端已采取相关措施并已尽合理努力进行审核，但不保证其内容的正确性、合法性或可靠性，相关责任由上传上述内容的用户承担。
<br/>5.用户应对蓉e聘-C端上的其他用户发布的内容自行加以判断，并承担因使用内容而引起的所有风险，包括但不限于因对内容的正确性、完整性或实用性的依赖而产生的风险。蓉易聘公司无法且不会对因前述风险而导致的任何损失或损害承担责任。
<br/>6.是否使用软件/网站服务下载或取得任何资料应由用户自行考虑并自负风险，因任何资料的下载而导致的用户电脑系统的任何损坏或数据丢失等后果，蓉e聘-C端不承担任何责任。
<br/>7.对于蓉易聘公司在线上或线下策划、发起、组织或是承办的任何招聘相关的活动（包括但不限于收取费用以及完全公益的活动），蓉e聘-C端不对上述招聘效果向用户作出任何保证或承诺，也不担保活动期间用户自身行为的合法性、合理性。由此产生的任何对于用户个人或者他人的人身或者是名誉以及其他损害，应由行为实施主体承担责任。
<br/>8.对于用户的投诉，蓉e聘-C端将尽合理努力进行核实和处理，履行平台的管理义务。根据国家相关法律法规的规定，蓉e聘-C端有权决定是否向公众或被投诉者公开投诉内容。
<br/><b>六、用户的个人信息权利</b>
<br/>1.蓉e聘-C端依法对用户的个人信息及隐私进行保护。
<br/>2.用户对于自己的个人信息享有包括但不限于以下权利：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随时查询及请求阅览，但因极少数特殊情况无法查询及提供阅览的除外；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随时请求补充或更正，但因极少数特殊情况无法补充或更正的除外。
<br/>3. 有关隐私政策的内容具体详见蓉e聘-C端《隐私政策》。
<br/><b>七、用户的平台使用义务</b>
<br/>1.本协议所称“平台使用”是指用户使用本平台服务所进行的任何行为，包括但不限于注册、登录、认证、账号管理、发布招聘信息、邀约面试以及其他通过蓉e聘-C端账号在本平台所进行的一切行为。
<br/>2.蓉e聘-C端用户在使用蓉e聘-C端服务时，应遵守中国通行法律法规以及适用的特定行业法律法规，包括但不限于《中华人民共和国民法典》《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《中华人民共和国数据安全法》《中华人民共和国就业促进法》《中华人民共和国劳动法》《中华人民共和国劳动合同法》《中华人民共和国商标法》《中华人民共和国著作权法》《全国人民代表大会常务委员会关于维护互联网安全的决定》《中华人民共和国保守国家秘密法》《中华人民共和国电信条例》《互联网信息服务管理办法》《计算机信息网络国际联网安全保护管理办法》《中华人民共和国计算机信息系统安全保护条例》《中华人民共和国计算机信息网络国际联网管理暂行规定》《网络招聘服务管理规定》《计算机信息系统国际联网保密管理规定》《网络信息内容生态治理规定》《互联网用户账号名称管理规定》。
<br/>3.禁止用户通过蓉e聘-C端平台制作、发送、复制、发布、传播违反《互联网信息服务管理办法》等国家相关法律法规的内容，包括但不限于：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;反对宪法所确定的基本原则的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;损害国家荣誉和利益的；煽动民族仇恨、民族歧视、破坏民族团结的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;破坏国家宗教政策，宣扬邪教和封建迷信的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;散布谣言、扰乱社会秩序、破坏社会稳定的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;侮辱或者诽谤他人，侵害他人合法权益的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或有悖道德、令人反感的内容的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;含有中国法律、法规、规章、条例以及任何具有法律效力的规范所限制或禁止的其他内容的。
<br/>4. 禁止用户通过蓉e聘-C端平台制作、发布、传播以下信息：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;涉及招聘未成年人等内容；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;涉及传销或直销、广告（寻求合作）等内容；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;涉及色情、淫秽等内容；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;涉及违法/政治敏感等内容；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;涉及虚假信息，包括但不限于不真实的公司信息、薪资、BOSS身份、个人简历、职位信息等；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;涉及虚假职位，包括但不限于发布的职位信息与其实际招聘的职位不符等；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其他违反<router-link tag="li" to="/index/jobPosting" >《蓉e聘-C端职位信息发布规则》</router-link>的信息。
<br/>5. 禁止利用蓉e聘-C端平台从事损害其他用户或蓉e聘-C端合法权益的行为，包括但不限于：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;冒充任何人或机构，包含但不限于冒充蓉e聘-C端工作人员或以虚假或不实的方式陈述或谎称与任何人或机构有关系的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;跟踪或以其它方式骚扰其他用户的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未经合法授权截获、篡改、收集、储存或删除他人信息、电子邮件或数据资料，或将已获知的此类资料用于任何非法或不正当目的的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以任何方式干扰或企图干扰蓉e聘-C端平台的正常运行，或者制作、发布、传播上述干扰蓉e聘-C端的工具或方法；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未能按照本平台的流程、规则进行注册、认证或使用服务，违反本平台的功能限制或运营策略，或采取任何措施规避前述流程、规则、限制或策略的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未经蓉e聘-C端公司许可，使用插件、外挂或通过其他第三方工具、运营平台或任何服务接入本服务或系统获取相关数据或信息的。
<br/>6. 禁止用户从事危害蓉e聘-C端平台生态的行为，包括但不限于：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;招聘他人从事违法活动；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以培训费、服装费等名义骗取求职者财物；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;恶意骚扰其他用户；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;利用本平台可能存在的漏洞恶意充值直豆、获取道具等虚拟产品或服务；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在本平台以外的任何第三方平台（包括但不限于淘宝、闲鱼等）售卖直豆、道具等虚拟产品或服务的行为；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过第三方平台或渠道（如淘宝店铺等）购买直豆、道具等虚拟产品或服务；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户使用虚假身份信息/公司信息进行注册或认证、发布虚假招聘或求职信息、发布含有传销、色情、反动等严重违法内容、对外传播面试聊天等通讯记录、拖欠大量农民工薪资的，均视为严重违反本协议。
<br/>7. 禁止用户利用蓉e聘-C端平台从事其他的违法行为，包括但不限于：
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;利用蓉e聘-C端提供的开聊服务从事欺诈、传销、刷流量、好评、违法物品营销等行为；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;冒用、混淆他人账号的昵称、头像、企业介绍发布招聘信息的，或冒充、利用他人名义对外招聘的；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;可能存在拖欠或未依法支付薪资或劳务报酬等可能损害劳动者或劳务人员合法权益的行为；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未经蓉e聘-C端公司的许可自行或授权、允许、协助任何第三人对平台内的任何信息内容进行非法获取；“非法获取”是指采用包括但不限于“蜘蛛”(spider)程序、爬虫程序、拟人程序等非真实用户或避开、破坏技术措施等非正常浏览的手段、方式，读取、复制、转存、获得数据和信息内容的行为；
<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为他人提供自动登录到本平台、代办或协助他人代办身份认证的服务或代售身份认证所需的相关材料或凭据。
<br/>用户违反上述任意一项规定的均构成违约，蓉e聘-C端有权按照本协议第八条的约定对其采取处置措施并追究其违约责任。
<br/><b>八、违约责任</b>
<br/>1.若蓉e聘-C端查实或有合理理由认为用户违反本协议第七条的，蓉e聘-C端有权对其采取删除、屏蔽相关信息、限制其使用部分或全部功能等处理措施；为防止损失的进一步扩大，蓉e聘-C端有权视情况紧急及严重程度，在不经事先通知的情况下暂停或终止向该用户提供部分或全部服务。如用户的违约行为导致蓉e聘-C端遭受任何损失的，蓉e聘-C端有权要求该用户向蓉e聘-C端赔偿全部损失。
<br/>2.如用户的违约行为导致任何第三人对蓉e聘-C端提出任何索赔或请求的，用户应当赔偿蓉e聘-C端或其他合作伙伴的损失，包括但不限于赔偿金、律师费、合理的调查费等相关费用。
<br/>3.用户投诉其他用户有违法行为或违反本协议的约定，投诉者应承担不实投诉所产生的全部法律责任。如侵犯他人的合法权益，投诉人应独立承担全部法律责任。如给蓉e聘-C端造成损失的，投诉人应对B蓉e聘-C端承担相应的赔偿责任。
<br/><b>九、关于用户在蓉e聘-C端上传或张贴的内容</b>
<br/>1.用户在蓉e聘-C端上传或张贴的内容（包括但不限于照片、文字、面试经历及心得评价等），视为用户授予蓉e聘-C端公司及其关联公司免费、非独家的使用权，蓉e聘-C端有权为展示、传播及推广前述张贴内容的目的，对上述内容进行复制、修改、出版等。该使用权持续至用户书面通知蓉e聘-C端不得继续使用，且蓉e聘-C端实际收到该等书面通知时止。
<br/>2.因用户上传或张贴的内容侵犯他人权利，导致任何第三方向蓉e聘-C端公司提出侵权或索赔要求的，用户应承担全部责任。
<br/>3.任何第三方对于用户在蓉e聘-C端的公开使用区域张贴的内容进行复制、修改、编辑、传播等行为的，该行为产生的法律后果和责任均由行为人承担，与蓉e聘-C端无关。
<br/><b>十、关于面试聊天等即时通讯服务</b>
<br/>1.蓉e聘-C端对该信息的采集、传输及存储均会采取加密、防泄露等相关措施。
<br/>2.为保护其他用户隐私，您不得下载、传播或公开发布本条规定的其他用户通讯信息，如面试聊天记录等。如因此造成蓉e聘-C端损失，或者侵害其他用户权益的，您应当承担违约责任或赔偿责任。
<br/><b>十一、注销服务</b>
<br/>用户有权随时请求注销蓉e聘-C端账号。关于注销账号的相关规则和流程，请参见《注销协议》。用户注销成功后，蓉e聘-C端将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。
<br/><b>十二、本协议条款的变更和修改</b>
<br/>蓉e聘-C端有权依法随时对本协议的任何条款进行变更和修改。一旦发生条款变动，我们将在蓉e聘-C端软件内进行更新及提示，或将最新版本的《用户协议》以系统消息、弹框或邮件的形式发送给用户阅读及确认接收。用户如果不同意条款的修改，应主动停止使用蓉e聘-C端或申请注销蓉e聘-C端账号，如未使用的付费权益将在注销后清空（相关退款事宜详见《注销协议》）。否则，如果用户继续使用用户账号，则视为用户已经接受本协议全部条款的修改。
<br/><b>十三、不可抗力</b>
<br/>1.“不可抗力”是指蓉e聘-C端不能合理控制、不可预见或即使预见亦无法避免的事件，该事件妨碍、影响或延误蓉e聘-C端根据本注册条款履行其全部或部分义务。该事件包括但不限于政府行为、自然灾害、战争、黑客袭击、电脑病毒、网络故障等。不可抗力可能导致蓉e聘-C端无法访问、访问速度缓慢、存储数据丢失、用户个人信息泄露等不利后果。
<br/>2.遭受不可抗力事件时，蓉e聘-C端可中止履行本协议项下的义务直至不可抗力的影响消除为止，并且不因此承担违约责任；但应尽最大努力克服该事件，减轻其负面影响。
<br/><b>十四、通知</b>
<br/>蓉e聘-C端向其用户发出的通知，将采用系统消息、弹窗、电子邮件或页面公告等形式。本《用户协议》的条款修改或其他事项变更时，蓉e聘-C端可以以上述形式进行通知。
<br/><b>十五、法律的适用和管辖</b>
<br/>本协议的生效、履行、解释及争议的解决均适用中华人民共和国的现行法律，本协议的签订地为中华人民共和国北京市朝阳区。若您与蓉e聘-C端发生任何争议，双方应尽量友好协商解决，如协商不成，您同意应将争议提交至本协议签订地的人民法院诉讼解决。本协议因与中华人民共和国现行法律相抵触而导致部分条款无效的，不影响其他条款的效力。
       </div>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.introduce {
  padding-top: 20px;
  line-height: 26px;
  color: #414a60;
  font-size: 14px;
  //margin-bottom: 40px;
  //text-indent: 2em; /* 2个字符的宽度 */
  .protocol {
    background: #fff;
    margin: 37px auto 55px auto;
    padding: 15px 45px 65px 45px;
    min-height: calc(100% - 330px);
    box-sizing: border-box;
  }
  .home-inner {
    max-width: 1200px;
  }
  .inner {
    max-width: 1200px;
    margin: 0 auto;
  }
}
.protocol h1 {
  text-align: center;
  margin-bottom: 20px;
  margin-top: 25px;
  font-size: 20px;
}
b{
    font-size: 16px;
}
p{
    padding: 0 !important;
    margin: 0 !important;
    font-weight: 600;
}
li{
    list-style: none;
    display: inline-block;
    color: #049cfd;
    font-weight: 600;
    cursor: pointer;
}
</style>
